// Libs
import React, { Component } from 'react'
import { Row, Col } from '../../components/Elemental'
import { connect } from 'react-redux'
import Papa from 'papaparse'
import _ from 'lodash'

// CSS
import './styles.scss'

// Actions
import { } from './actions'

// Components/Containers
import Breadcrumb from '../../components/Breadcrumb'
import Button from '../../components/Button'

// Actions
import { changeImporterSelectedFile, changeImporterSelectedCompany, changeImporterCases, changeImporterStatus, changeImporterSummary } from './actions'

// Constants
import { asyncForEach, sleep, changeCases, convertArrayToObject } from './contants'

// Normalize
import * as normalize from './normalize'
import { capitalize, currency } from '../../constants/normalize'

// Other
import { exportAsXls } from '../../constants/others'

// Validate
import * as validate from './validate'

// Axios
import { serverAPI } from '../../index'

class Importer extends Component {
  uploadCases = (file) => {
    const { summary, changeImporterSelectedFile, changeImporterCases, changeImporterSummary } = this.props

    let data = []
    let count = 0

    changeImporterSelectedFile(file.name)

    Papa.parse(file, {
      skipEmptyLines: true,
      encoding: "UTF-8",
      step: (results, parser) => {
        // if(count === 0) {
        //   count++
        //   return
        // }

        let fields = [{ value: '', error: '' }]
        let lawsuitNumberTag = ''
        let clientNameTag = ''
        let maxValueTag = ''
        let obligationTag = ''

        results.data[0].map((item, index) => {
          let value = item

          // Normalize
          if ([0].indexOf(index) > -1) {
            console.log('Before', value)
            value = normalize.lawsuitNumber(item)
            console.log('After', value)
          }

          if ([2].indexOf(index) > -1) value = capitalize(item)
          if ([5, 6].indexOf(index) > -1) value = currency(item)
          if ([3].indexOf(index) > -1) value = normalize.oabNumber(item)

          // Replace tags
          if ([0].indexOf(index) > -1) lawsuitNumberTag = value
          if ([2].indexOf(index) > -1) clientNameTag = item
          if ([5].indexOf(index) > -1) maxValueTag = value
          if ([7].indexOf(index) > -1) obligationTag = item
          if ([11].indexOf(index) > -1) value = item ? normalize.formatImporterDate(item) : ''

          if ([9].indexOf(index) > -1) {
            value = value.replace(/#n[úu]mero-do-processo/, lawsuitNumberTag)
            value = value.replace(/#nome-do-cliente/, clientNameTag)
            value = value.replace(/#outras-obriga[çc][õo]es/, obligationTag)

            let maxValue = value.match(/#al[çc]ada.+%/)

            if (maxValue) {
              let maxValuePercentage = maxValue[0].replace(/#al[çc]ada/, '').replace('%', '')
              maxValuePercentage = Number(maxValuePercentage) / 100

              maxValueTag = maxValueTag.replace(/\./g, '').replace(/\,/g, '.')
              maxValueTag = (maxValueTag * maxValuePercentage).toFixed(2)
              maxValueTag = `R$ ${currency(String(maxValueTag))}`

              value = value.replace(/(#al[çc]ada).+%/, maxValueTag)
            }
          }

          fields = [...fields, { value, error: '' }]
        })

        if (count !== 0) data = [...data, fields]

        count++
      },
      complete: () => {
        if (!_.isEmpty(data)) {
          changeImporterCases(data)
          changeImporterSummary({ ...summary, total: data.length })
        }
      }
    })
  }

  importCases = async () => {
    const { selectedCompany, headers, cases, summary, changeImporterCases, changeImporterStatus, changeImporterSummary, importImporterCase } = this.props

    changeImporterStatus('importing')

    let myCases = [...cases]
    let mySummary = { ...summary }
    let fieldsIndex = 0

    for (let fields of myCases) {
      const startTime = new Date().getTime()

      myCases = changeCases(myCases, fieldsIndex, 'value', 'Importando')

      changeImporterCases(myCases)

      let fieldIndex = 0
      let hasError = false

      for (let field of fields) {
        const value = field.value

        // Validate fields
        if ([1, 2, 3, 6].indexOf(fieldIndex) > -1 && !value) {
          myCases[fieldsIndex][fieldIndex].error = `"${headers[fieldIndex].label}" é obrigatório.`
          hasError = true
        }

        if ([4].indexOf(fieldIndex) > -1 && value.length > 6) {
          myCases[fieldsIndex][fieldIndex].error = `"${headers[fieldIndex].label}" possui mais de 6 caracteres.`
          hasError = true
        }

        if ([2, 5].indexOf(fieldIndex) > -1 && !validate.uf(value)) {
          myCases[fieldsIndex][fieldIndex].error = `"${headers[fieldIndex].label}" não possui uf valida.`
          hasError = true
        }

        if ([11].indexOf(fieldIndex) > -1 && !validate.classifiers(value)) {
          myCases[fieldsIndex][fieldIndex].error = `"${headers[fieldIndex].label}" não esta nos padrões de formatação.`
          hasError = true
        }

        fieldIndex++
      }

      // Verify if case is already in plataform
      let lawsuitNumber = fields[1].value

      if (!hasError) {
        try {
          await serverAPI.get(`/case/check/${lawsuitNumber}`)
        } catch (e) {
          switch (e.response.status) {
            case 460:
              myCases[fieldsIndex][1].error = '"Número de Processo" já existente na plataforma.'
              break;
            default:
              myCases[fieldsIndex][0].error = e.response.data
          }

          hasError = true
        }
      }

      // Fetch lawyer
      let oabNumber = fields[4].value
      let oabUf = fields[5].value

      if ((!oabNumber || !oabUf) && !hasError) {
        try {
          const response = await serverAPI.get(`/case/${lawsuitNumber}/new-lawyer`)

          const { data: { oab_number: oabNumber, oab_uf: oabUf } } = response

          myCases[fieldsIndex][4].value = oabNumber
          myCases[fieldsIndex][5].value = oabUf
        } catch (e) {
          switch (e.response.status) {
            case 404:
              myCases[fieldsIndex][1].error = 'O caso não foi encontrado em nossos parceiros.'
              break;
            case 461:
              myCases[fieldsIndex][4].error = 'O caso foi encontrado em nossos parceiros porém sem advogado do autor.'
              break;
            case 462:
              myCases[fieldsIndex][4].error = 'O advogado não foi encontrado em nosso sistema.'
              break;
            default:
              myCases[fieldsIndex][0].error = e.response.data
          }
          hasError = true
        }
      }

      // Import case
      if (!hasError) {
        try {
          const data = convertArrayToObject(headers, [myCases[fieldsIndex]], 'value')

          await serverAPI.post('/case/company', {
            ...data[0],
            companyId: selectedCompany,
            fromImporter: true
          })

          myCases = changeCases(myCases, fieldsIndex, 'value', 'Importado')
          mySummary = { ...mySummary, imported: mySummary.imported + 1 }
        } catch (e) {
          switch (e.response.status) {
            case 460:
              myCases[fieldsIndex][1].error = '"Número de Processo" já existente na plataforma.'
              break;
            case 462:
              myCases[fieldsIndex][4].error = 'O advogado não foi encontrado em nosso sistema.'
              break;
            case 463:
              myCases[fieldsIndex][11].error = '"Classificadores" possui um id não existente na plataforma.'
              break;
            default:
              myCases[fieldsIndex][0].error = e.response.data
          }

          hasError = true
        }
      }

      if (hasError) {
        myCases = changeCases(myCases, fieldsIndex, 'value', 'Erro')
        mySummary = { ...mySummary, errors: mySummary.errors + 1 }
      }

      fieldsIndex++

      changeImporterCases(myCases)

      const endTime = new Date().getTime()
      const time = endTime - startTime
      const done = mySummary.imported + mySummary.errors
      const left = mySummary.total - done
      const averageTime = ((mySummary.averageTime * (done - 1)) + time) / done

      mySummary = {
        ...mySummary,
        averageTime,
        timeLeft: averageTime * left
      }

      changeImporterSummary(mySummary)
    }

    changeImporterStatus('imported')
  }

  exportCases = () => {
    const { headers, cases } = this.props

    const data = convertArrayToObject(headers, cases)

    exportAsXls(data, 'Importação', 'Importação')
  }

  handleScroll = e => {
    const bodyWrapper = e.target

    this.refs.header.scrollLeft = bodyWrapper.scrollLeft
  }

  render() {
    const { user: { companies }, selectedFile, selectedCompany, headers, cases, status, summary, changeImporterSelectedFile, changeImporterSelectedCompany } = this.props
    const { uploadCases, importCases, exportCases, handleScroll } = this

    return (
      <div className="importer">
        <Breadcrumb routes={['Inserir Caso', 'Importar']} />
        {/* Rethink this input for client version */}
        <div className="importer__question">
          <p>Qual o arquivo que deseja importar?</p>
          <label>
            {selectedFile ? selectedFile : 'Escolha o arquivo'}
            <input
              type="file"
              hidden
              accept=".csv"
              onChange={e => uploadCases(e.target.files[0])} />
          </label>
        </div>
        {/* Rethink this select for client version */}
        <div className="importer__question">
          <p>Para qual empresa deseja importar?</p>
          <select
            value={selectedCompany}
            onChange={e => changeImporterSelectedCompany(e.target.value)}>
            <option value="" defaultValue>Escolher a Empresa</option>
            {companies.map(company => (
              <option key={company.id} value={company.id}>
                {company.fantasyName ? company.fantasyName : company.name}
              </option>
            ))}
          </select>
        </div>
        <div className="importer__table">
          <div className="importer__summary">
            <ul>
              <li>Total<span>{summary.total}</span></li>
              <li>Importados<span>{summary.imported}</span></li>
              <li>Erros<span>{summary.errors}</span></li>
              <li>Tempo Restante<span>{Math.round(summary.timeLeft / 60000)} MIN</span></li>
            </ul>
          </div>
          <div ref="header" className="importer__header">
            <div className="importer__row">
              {headers.map(({ value, label, optional }) => (
                <div className="importer__field" key={value}>
                  <p>{label}</p>
                  {optional &&
                    <span>(opcional)</span>
                  }
                </div>
              ))}
            </div>
          </div>
          <div
            ref="bodyWrapper"
            className="importer__body-wrapper"
            onScroll={handleScroll}>
            <div className="importer__body">
              {!_.isEmpty(cases) && cases.map((fields, index) => (
                <div key={index} className="importer__row">
                  {fields.map(({ value, error }, index) => {
                    if (value === undefined) {
                      console.log(index, error, value, fields)
                    }
                    return (
                      <div
                        className={error ? "importer__field importer__field--error" : "importer__field"}
                        key={index}>
                        <p>{value}</p>
                        {!error && value.length > 30 &&
                          <div className={`importer__modal importer__modal--${index + 1 === fields.length ? 'last' : index}`}>
                            <span></span>
                            <div>
                              <p>TEXT COMPLETO</p>
                              <p>{value}</p>
                            </div>
                          </div>
                        }
                        {error &&
                          <div className={`importer__modal importer__modal--${index + 1 === fields.length ? 'last' : index} importer__modal--error`}>
                            <span></span>
                            <div>
                              <p>PROBLEMA</p>
                              <p>{error}</p>
                            </div>
                          </div>
                        }
                      </div>
                    )
                  })}
                </div>
              ))}
              {_.isEmpty(cases) &&
                <div className="importer__row">
                  {headers.map(header => (
                    <div className="importer__field" key={header.value} />
                  ))}
                </div>
              }
            </div>
          </div>
        </div>
        <Row>
          <Col sm="100%" md="50%" lg="25%">
            <Button
              type="submit"
              gutterTop={40}
              disabled={!selectedCompany || _.isEmpty(cases) || status === 'importing' ? true : false}
              onClick={status === 'imported' ? exportCases : importCases}>
              {status === 'imported' ? 'Exportar' : 'Importar'}
            </Button>
          </Col>
        </Row>
      </div>
    )
  }
}

Importer = connect(state => ({
  user: state.auth.user,
  selectedFile: state.importer.selectedFile,
  selectedCompany: state.importer.selectedCompany,
  headers: state.importer.headers,
  cases: state.importer.cases,
  status: state.importer.status,
  summary: state.importer.summary
}), { changeImporterSelectedFile, changeImporterSelectedCompany, changeImporterCases, changeImporterStatus, changeImporterSummary })(Importer)

export default Importer
